module.exports = __webpack_public_path__ + "img/216.3175f98d.jpg";